import React from "react";
// react components used to create a google map
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

// @material-ui/icons
import Map from "@material-ui/icons/Map";
import AddLocation from "@material-ui/icons/AddLocation";
import Place from "@material-ui/icons/Place";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import IconCard from "components/Cards/IconCard.jsx";

const SatelliteMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={3}
      mapTypeId={"satellite"}
      defaultCenter={{ lat: 40.748817, lng: -73.985428 }}
      defaultOptions={{
        scrollwheel: false
      }}
    >
      <Marker position={{ lat: 40.748817, lng: -73.985428 }} />
    </GoogleMap>
  ))
);

const RegularMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={8}
      defaultCenter={{ lat: 40.748817, lng: -73.985428 }}
      defaultOptions={{
        scrollwheel: false
      }}
    >
      <Marker position={{ lat: 40.748817, lng: -73.985428 }} />
    </GoogleMap>
  ))
);

const CustomSkinMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={13}
      defaultCenter={{ lat: 40.748817, lng: -73.985428 }}
      defaultOptions={{
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }]
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }]
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
          },
          { featureType: "poi.park", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "on" }]
          },
          { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "simplified" }]
          }
        ]
      }}
    >
      <Marker position={{ lat: 40.748817, lng: -73.985428 }} />
    </GoogleMap>
  ))
);

class GoogleMaps extends React.Component {
  render() {
    return (
      <GridContainer>
        <ItemGrid xs={12} sm={12} md={12}>
          <IconCard
            title="Satellite Map"
            iconColor="rose"
            icon={Map}
            content={
              <SatelliteMap
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA2TE-ks3DUffic8hlC_mH54-0wlOc8pBY"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `280px`, borderRadius: "6px", overflow: "hidden" }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            }
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={6}>
          <IconCard
            title="Regular Map"
            iconColor="rose"
            icon={AddLocation}
            content={
              <RegularMap
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA2TE-ks3DUffic8hlC_mH54-0wlOc8pBY"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `280px`, borderRadius: "6px", overflow: "hidden" }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            }
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={6}>
          <IconCard
            icon={Place}
            iconColor="rose"
            title="Custom Skin & Settings Map"
            content={
              <CustomSkinMap
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA2TE-ks3DUffic8hlC_mH54-0wlOc8pBY"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `280px`, borderRadius: "6px", overflow: "hidden" }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            }
          />
        </ItemGrid>
      </GridContainer>
    );
  }
}

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/views/Maps/GoogleMaps.jsx